import { numberWithCommas } from "./strings";

export const calculateTotalPrice = (row) => {
  const { quantity, price, commission, stage_type } = row;

  if (quantity && price) {
    if (
      stage_type === "tpPurchaseOrders" ||
      stage_type === "tpProformaInvoices"
    ) {
      return numberWithCommas(parseFloat(quantity * price));
    } else {
      return numberWithCommas(
        parseFloat(quantity * price * (1 + commission / 100.0))
      );
    }
  } else return 0;
};
